module.exports = __webpack_public_path__ + "img/driver-mp-code.99c9038d.jpg";